import {createABTestStore} from '#imports';

/**
 * This is a global composable shared accross the modules.
 *
 * No need to fetch the campaigns nor variations, it's handle automatically by the plugin:
 * lib-front-core/nuxt-features-module/src/runtime/plugins/abtest.ts
 *
 * @usage
 *
 * ```ts
 * const ABTestStore = useABTestStore();
 *
 * const isMyFeatureActivated = getVariation('my-ab-test-campaign') === 'treatment'
 * ```
 */
export const useABTestStore = createABTestStore('global-abtest-store');
